export default __webpack_public_path__ + "static/media/Capture.8a33ebef.PNG";